import {translations as defaultTranslation} from '../i18n'

export const translations = {
    fr: {
        errorTypeEnum: {
            impossibleToPerfomCommandOnNonExistingProviderCompany: 'Votre demande est invalide',
            activityAlreadyAssignedToProviderCompany: 'Cette activité est déjà associée à ce fournisseur',
            activityIsNotAssignedToProviderCompany: 'Cette activité n\'est pas associée à ce fournisseur',
            callOutChargeRangeOverlapExistingCallOutChargeRange: 'Les distances d\'intervention ne sont pas contiguës',
            callOutChargeRangeDoesNotTouchAnotherExistingCallOutChargeRange: 'Les distances d\'intervention ne sont pas contiguës',
            interventionPeriodOverlapAnothers: 'Des périodes d\'intervention se chevauchent',
            interventionPeriodDefinedAsReferenceCanNotBeRemovedIfNotTheOnlyOne: 'La période d\'intervention de référence ne peut être supprimée',
            impossibleToDefineServiceChargeInPercentageForAReferencePeriod: 'Le tarif de la période d\'intervention de référence ne peut pas être un pourcentage',
            impossibleToRemoveActivityBecauseOfLinkedInterventionPeriod: 'Des périodes d\'intervention sont définies pour cette activité',
            openingTicketPurposesNotAvailableForThisProviderContact: 'Une raison d\'ouverture de ticket n\'est pas disponible pour ce contact fournisseur',
            openingTicketPurposesNotAvailableForThisInterventionPeriod: 'Une raison d\'ouverture de ticket n\'est pas disponible pour cette période d\'intervention',
            timelimitsCantBeDefinedWithSameOpeningTicketPurposes: 'Une raison d\'ouverture de ticket ne peut avoir qu\'un seul délai',
            repairTimelimitShouldBeGreaterThanCorrespondingInterventionTimelimit: 'Le délai maximal de réparation d\'une raison d\'ouverture de ticket doit être suppérieur à celui d\'intervention',
            interventionPeriodIsIncoherent: {
                startDateIsNotMinusThanEndDate: 'La date de début doit précéder la date de fin',
                onePeriodRangeHaveDuplicateWeekDay: 'Des jours de la semaine sont dupliqués',
                onePeriodRangeHaveItsTimeslotThatOverlap: 'Des plages horaires se chevauchent',
                periodRangeOverlapAnotherOne: 'Des périodes se chevauchent',
                exclusionsHaveDuplicateSpecificDays: 'Des exclusions comportent des jours dupliqués',
                oneDayOfExclusionsHaveTimeslotThatOverlap: 'Des exclusions comportent des plages horaires se chevauchant',
                specificDaysPeriodHaveDuplicateDays: 'Des jours spécifiques sont dupliqués',
                specificDaysPeriodHaveTimeslotsThatOverlap: 'Des jours spécifiques comportent des plages horaires se chevauchant'
            }
        },
        searchStream: {
            xs: 'rechercher',
            sm: 'rechercher un fournisseur'
        },
        searchCoverage: {
            xs: 'couverture',
            sm: 'couverture fournisseur'
        },
        searchProviderContactStream: {
            xs: 'rechercher',
            sm: 'rechercher un contact fournisseur'
        },
        searchActivity: {
            xs: 'rechercher',
            sm: 'rechercher une activité'
        },
        searchSummary: 'synthèse de recherche',
        useSearchProviderFilters: 'Seuls {count} résultats ont été chargés, merci d\'utiliser les filtres pour affiner votre recherche',
        provider: 'fournisseur',
        providerz: 'entreprise',
        providersz: 'entreprises',
        newProvider: 'nouveau fournisseur',
        selectProvider: 'choisir un fournisseur',
        providerDirectory: 'annuaire',
        useSearchProviderContactFilters: 'Seuls {count} résultats ont été chargés, merci d\'utiliser les filtres pour affiner votre recherche',
        providerContact: 'contact fournisseur',
        providerContacts: 'contacts fournisseur',
        providerContactz: 'contact',
        providerContactsz: 'contacts',
        newProviderContact: 'nouveau contact fournisseur',
        updateProviderContact: 'modification',
        myProviderContacts: 'mes fournisseurs',
        patrimonyProviderContactText: 'le fournisseur à été affilié au patrimoine',
        agencyProviderContactText: 'le fournisseur est référencé sur le portefeuille du patrimoine',
        contactInformation: 'coordonnées',
        providers: 'fournisseurs',
        tickets: 'tickets',
        synthesis: 'synthèse',
        siret: 'siret',
        documents: 'documents',
        interventionDelay: 'délai d\'intervention',
        interventionDelayText: 'Délai entre la prise en charge d\'une mission par un fournisseur et le début de son intervention',
        interventionNumber: 'nombre d\'interventions',
        interventionNumberText: 'comptées sur une période',
        missionAcceptedDelay: 'délai de prise en charge',
        missionAcceptedDelayText: 'Délai entre le premier appel au fournisseur et la prise en charge effective de la mission par celui-ci',
        repairDelay: 'délai de réparation',
        repairDelayText: 'Délai entre la prise en charge d\'une mission par un fournisseur et la fin de son intervention',
        callBeforeMissionAccepted: 'nombre d\'appels avant prise en charge',
        callBeforeMissionAcceptedText: 'Nombre d\'appels émis vers un fournisseur avant qu\'il prenne en charge la mission',
        intervention: 'intervention',
        missionAccepted: 'prise en charge',
        repair: 'réparation',
        delays: 'délais',
        callCount: 'nombre d\'appels',
        selectDateRange: 'sélectionner une période',
        filterStats: 'filtrer les statistiques',
        interventionCount: 'nombre d\'interventions',
        scores: 'indicateurs de confiance',
        undeclaredWorkReportState: {
            xs: 'TD',
            sm: 'travail dissimulé'
        },
        insuranceReportState: {
            xs: 'AS',
            sm: 'assurances'
        },
        specificDocumentsReportState: {
            xs: 'SP',
            sm: 'spécifique actradis'
        },
        associateProvider: 'associer un fournisseur',
        associateDissociatePatrimonies: 'patrimoines',
        assignRemoveActivities: 'activités',
        addActivity: 'ajouter une activité',
        batiref: 'Batiref',
        actradis: 'Actradis',
        actradisReportStateEnum: {
            ok: 'les documents {text} sont valides',
            documentExpiredInLessThan15Days: 'les documents {text} sont sur le point d\'expirer',
            documentExpired: 'les documents {text} ont expiré',
            noDocument: 'les documents {text} sont indisponibles'
        },
        nameType: 'type de contact',
        nameTypeEnum: {
            civilName: 'individu',
            poorName: 'service'
        },
        gender: 'civilité',
        genderEnum: {
            male: 'M.',
            female: 'Mme.'
        },
        statsCorrupted: 'Certaines données sont invalides',
        activity: 'activité',
        activities: 'activités',
        activitiez: 'activité(s)',
        byActivity: 'par activité',
        assignActivity: 'associer une activité',
        unAssignActivity: 'dissocier l\'activité',
        unAssignActivityText: [
            'Vous êtes sur le point de dissocier l\'activité {label}.'
        ],
        newInterventionPeriod: 'nouvelle période d\'intervention',
        removeInterventionPeriod: 'supprimer la période d\'intervention',
        removeInterventionPeriodText: [
            'Vous êtes sur le point de supprimer la période d\'intervention {label}.'
        ],
        interventionZone: 'zone d\'intervention',
        serviceCharge: 'tarif horaire',
        percentageServiceChargeInfo: '{percentage} % du tarif de référence',
        callOutCharge: 'frais de déplacement',
        startRange: 'distance minimale',
        endRange: 'distance maximale',
        periodTypeEnum: {
            dateTimePeriod: 'période',
            weekDaysPeriod: 'jours de la semaine',
            specificDaysPeriod: 'jours spécifiques'
        },
        timeSlot: 'plage horaire',
        addTimeSlot: 'ajouter une plage horaire',
        removeTimeSlot: 'supprimer la plage horaire',
        timeSlotTypeEnum: {
            allDayLong: 'toute la journée',
            hourPeriods: 'plage horaire'
        },
        chargeTypeEnum: {
            chargePercentage: '%',
            fixChargeValue: '€'
        },
        period: 'période',
        periodRanges: 'jours de la semaine',
        addPeriodRange: 'ajouter une période',
        removePeriodRange: 'supprimer la période',
        exclusions: 'exclusions',
        addExclusion: 'ajouter une exclusion',
        removeExclusion: 'supprimer l\'exclusion',
        addDay: 'ajouter un jour',
        removeDay: 'supprimer le jour',
        removeDayRange: 'supprimer la période',
        subscription: 'abonnement',
        forWhat: 'pour quoi',
        forWhatEnum: {
            requestForQuotation: 'devis',
            urgency: 'urgence'
        },
        forWho: 'pour qui',
        forWhoEnum: {
            individuals: 'particuliers',
            professionals: 'professionnels'
        },
        defineContactInfo: 'contact de l\'entreprise',
        repairTimelimit: 'délai maximum de réparation',
        repairTimelimitRate: 'respect des délais de réparation',
        interventionTimelimit: 'délai maximum d\' intervention',
        interventionTimelimitRate: 'respect des délais d\' intervention',
        openingTicketPurposes: 'raisons d\'ouverture de ticket',
        commitments: 'engagements',
        commitmentCompliancyRate: 'taux de respect des engagements',
        compliantTickets: 'tickets respectant les engagements',
        notCompliantTickets: 'tickets ne respectant pas les engagements',
        qualifiedTickets: 'tickets éligibles',
        copyActivity: 'copier une activité',
        copyProviderContactActivity: 'Attention les engagements de délais ne seront pas copiés',
        copyInterventionPeriod: 'copier les engagements d\'une période d\'intervention',
        fillinAssistant: 'aide à la saisie',
        linkedWithInfo: {
            linkedToPatrimony: 'fournisseur sous contrat ou associé au patrimoine',
            linkedToAgency: 'fournisseur référencé par l\'agence',
            linkedToCompany: 'fournisseur référencé par le client',
            linkedToContract: 'fournisseur sous contrat'
        },
        foundViaInterventionZone: 'fournisseur à proximité',
        coverage: 'couverture',
        coverageRate: 'taux de couverture global',
        providerCoverage: 'couverture',
        cities: 'villes',
        cityCoverageMap: 'carte des villes',
        byCity: 'par ville',
        department: 'département',
        departmentCoverageMap: 'carte des départements',
        byDepartment: 'par département',
        zipCodes: 'code postal',
        zipCodesInfo: 'liste de codes postaux séparés par une virgule',
        coverageActivityIsRequired: 'Au moins une activité doit être sélectionnée'
    }
}

export default {...defaultTranslation.fr, ...translations.fr}


// WEBPACK FOOTER //
// ./lib/provider/i18n.js